/**
 * Facet WP plugin scripts
 */

import $ from 'jquery';
import { lazyLoadObserve } from './lazyLoad';
import Jump from 'jump.js'
import { easeOutQuad } from 'ez.js';

window.addEventListener('load', () => {
  if (typeof FWP === 'object') {

    // For the first init it doesn't always triggers the `facetwp-loaded` event
    // So use this aswell
    if (FWP.loaded) {
      console.log('FWP Loaded');
    }

    // This is needed to make the scrolltop after facet has loaded the new content after paging
    let hasRefreshed = false;
    const fwpPager = Array.from(document.getElementsByClassName('facetwp-page'));
    fwpPager.forEach((pager) => {
      pager.addEventListener('click', function () {
        hasRefreshed = true;
      })
    })

    const loaders = Array.from(document.getElementsByClassName('js-loader'));
    const itemsList = document.querySelector('.facetwp-template');

    $(document).on('facetwp-loaded', function () {
      const defaultObserver = lazyLoadObserve();
      defaultObserver.observe();

      if (hasRefreshed) {
        Jump('.main', {
          duration: 800,
          easing: easeOutQuad,
        });
      }

      if (loaders.length) {
        loaders.forEach((loader) => {
          loader.classList.remove('is-loading');
        })
      }

      itemsList.classList.remove('is-loading');
    });

    $(document).on('facetwp-refresh', function() {
      if (loaders.length) {
        loaders.forEach((loader) => {
          loader.classList.add('is-loading');
        })
      }

      itemsList.classList.add('is-loading');
    });

    /**
     * Move Extra card into Posts List
     */
    moveExtraCardIntoPostList();
    if (FWP.loaded) {
      const defaultObserver = lazyLoadObserve();
      defaultObserver.observe();
    }
    document.addEventListener('facetwp-loaded', function() {
      moveExtraCardIntoPostList();
      const defaultObserver = lazyLoadObserve();
      defaultObserver.observe();
    });
  }
});


/**
 * Force the custom lat/lng/zoom only on initial page load
 */
window.addEventListener('DOMContentLoaded', function() {
  if ('undefined' !== typeof FWP && 'undefined' !== typeof FWP.hooks) {
    FWP.hooks.addFilter('facetwp_map/fit_bounds', function(fit_bounds) {
      return false;
    });
  }
});

function moveExtraCardIntoPostList() {
  let currentEstablishmentType = 'default';
  if ( FWP.facets && FWP.facets['type_etablissement'] && FWP.facets['type_etablissement'].length == 1 ) {
    currentEstablishmentType = FWP.facets['type_etablissement'][0]
  }
  console.log(FWP.facets);
  // console.log(currentEstablishmentType);
  const extraCardSample = document.querySelector('.js-extra-card .posts__item[data-slug="' + currentEstablishmentType + '"]');
  const postsList = document.querySelector('.facetwp-template ul');
  const existingExtraCard = document.querySelector('.facetwp-template .card--extra');
  // console.log(extraCardSample);
  if (existingExtraCard) return; // prevent duplicate post extra
  if ( extraCardSample && postsList ) {
    const newExtraCard = extraCardSample.cloneNode(true);
    if ( postsList.children.length > 5 ) {
      postsList.insertBefore(newExtraCard, postsList.children[5]);
    } else {
      postsList.appendChild(newExtraCard);
    }
  }
}
